import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP plugins exactly once — every animation module imports from here
// so plugin registration is never duplicated or forgotten.
gsap.registerPlugin(ScrollTrigger);

export { gsap, ScrollTrigger };
